import affiliate from './fr/affiliate'
import bankTransfer from './fr/bankTransfer'
import cart from './fr/cart'
import cartAndWarehouse from './fr/cartAndWarehouse'
import common from './fr/common'
import consult from './fr/consult'
import debt from './fr/debt'
import distribution from './fr/distribution'
import estimation from './fr/estimation'
import form from './fr/form'
import home from './fr/home'
import kol from './fr/kol'
import order from './fr/order'
import orderDetail from './fr/orderDetail'
import packages from './fr/package'
import pay from './fr/pay'
import pecenter from './fr/pecenter'
import points from './fr/points'
import previewPackage from './fr/previewPackage.json'
import previewPackageOptimize from './fr/previewPackageOptimize'
import product from './fr/product'
import returnChange from './fr/returnChange'
import search from './fr/search'
import shareCoupon from './fr/shareCoupon'
import sharePackage from './fr/sharePackage'
import shoppingGuide from './fr/shoppingGuide'
import site from './fr/site'
import status from './fr/status'
import storage from './fr/storage'
import tag from './fr/tag'
import tips from './fr/tips'
import transport from './fr/transport'
import uniOrder from './fr/uniOrder'
import warnTips from './fr/warnTips'
export default {
  form,
  home,
  search,
  cart,
  product,
  order,
  pecenter,
  pay,
  common,
  estimation,
  packages,
  orderDetail,
  warnTips,
  status,
  tips,
  storage,
  uniOrder,
  bankTransfer,
  distribution,
  site,
  consult,
  transport,
  previewPackage,
  sharePackage,
  debt,
  previewPackageOptimize,
  points,
  shareCoupon,
  shoppingGuide,
  tag,
  cartAndWarehouse,
  affiliate,
  returnChange,
  kol,
}
